module.exports = __webpack_public_path__ + "static/ImagenBanner-6a92fe5ee4b82756fc6e71269aa0e410.png";